import { useState } from "react";
import LayoutActividad from "../../../components/LayoutActividad";
import Imagen1 from "../../../images/modulo9/elegible1.png";
import Imagen2 from "../../../images/modulo9/elegible2.png";
import Imagen3 from "../../../images/modulo9/elegible3.png";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { modulo9 } from "../../../routes/Module9";
import Sidebar from "../Sidebar";
import Card from "../../../components/Card";
import GuiaDocente from "../../../components/GuiaDocente";
import AudioPlayer from "../../../audioPlayer/AudioPlayer";
import Audio from "../../../audios/modulo9/Actividad 4.mp3";

const Actividad5 = () => {
  const [ans1, setAns1] = useState({
    value: "",
    valid: "",
    correctValue: "requisitos",
  });
  const [answers, setAnswers] = useState({
    ans1: { value: "", valid: "", correctValue: "0" },
    ans2: { value: "", valid: "", correctValue: "1" },
    ans3: { value: "", valid: "", correctValue: "0" },
    ans4: { value: "", valid: "", correctValue: "0" },
    ans5: { value: "", valid: "", correctValue: "1" },
    ans6: { value: "", valid: "", correctValue: "1" },
  });
  const infoUnidad = modulo9.content[0];
  const infoAct = modulo9.content[0].activities[3];
  const crumbs = [
    {
      title: modulo9.title,
      url: "/" + modulo9.url,
    },
    {
      title:
        modulo9.content.length === 1
          ? `${infoAct.name}`
          : `${infoUnidad.name} > ${infoAct.name}`,
      url: infoAct.path,
    },
  ];

  const pages = {
    titleNext: `${modulo9.content[0].activities[4].name}`,
    linkNext: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[4].path}`,
    titlePrev: `${modulo9.content[0].activities[2].name}`,
    linkPrev: `${modulo9.url}/${modulo9.content[0].path}/${modulo9.content[0].activities[2].path}`,
  };

  const metadata = {
    color: modulo9.color,
    title: `${modulo9.title} - ${infoAct.name}`,
    name: modulo9.title,
  };

  const handleAnswers = (event, name) => {
    if (answers[name]["value"] === event.target.value) {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: "2" },
      });
    } else {
      setAnswers({
        ...answers,
        [name]: { ...answers[name], value: event.target.value },
      });
    }
  };
  const validateAnswers = (event) => {
    event.preventDefault();
    let newAnswers = answers;
    Object.keys(newAnswers).forEach(
      (key) =>
        (newAnswers[key]["valid"] =
          answers[key]["correctValue"].toUpperCase() ===
          answers[key]["value"].toUpperCase()
            ? "is-valid"
            : "is-invalid")
    );
    setAnswers({ ...newAnswers });
  };

  console.log("m", ans1.valid);

  return (
    <LayoutActividad
      pages={pages}
      crumbs={crumbs}
      sidebar={<Sidebar />}
      modulo={metadata}
    >
      <p>
        <small className={`c-${modulo9.color} hat-text`}>
          <FontAwesomeIcon icon={faEdit} /> Trabajamos con las palabras
        </small>
      </p>

      <h2 className="mb-5">{infoAct.name}</h2>
          <AudioPlayer track={Audio} />
      <ul>
        <li>¿Quién puede ser presidente, vicepresidente o ministro?</li>
      </ul>
      <div className="row mb-3 px-3">
        <div className="col-md-6 col-12">
          <Card>
            <h6>SI QUIERES SER PRESIDENTE O VICEPRESIDENTE</h6>
            <ul>
              <li>Puedes ser hombre o mujer.</li>
              <li>Debes haber nacido en el Perú.</li>
              <li>Tienes que tener 35 años o más.</li>
              <li>
                No puedes ser miembro de las Fuerzas Armadas o de la Policía
                Nacional.
              </li>
              <li>
                No puedes estar sentenciado por haber cometido algún delito.
              </li>
              <li>Deberás ser elegido por votación popular.</li>
            </ul>
          </Card>
        </div>
        <div className="col-md-6 col-12">
          <Card>
            <h6>SI QUIERES SER MINISTRO</h6>
            <ul>
              <li>Puedes ser hombre o mujer.</li>
              <li>Debes haber nacido en el Perú.</li>
              <li>Tienes que tener 25 años o más.</li>
              <li>
                Puedes ser miembro de las Fuerzas Armadas o de la Policía
                Nacional.
              </li>
              <li>
                No puedes estar sentenciado por haber cometido algún delito.
              </li>
              <li>Te designará el presidente.</li>
            </ul>
          </Card>
        </div>
      </div>
      <ul>
        <li>
          Ahora piensa. ¿Cuál de nuestros amigos puede ser presidente,
          vicepresidente o ministro? Marca con un check.
        </li>
      </ul>

      <div className="row align-items-end mt-3">
        <div className="col-md-4 col-12 mt-3">
          <img src={Imagen1} alt="amigos" className="img-fluid mb-2" />
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans1.valid}
              type="checkbox"
              value="1"
              checked={answers.ans1.value === "1"}
              onChange={(event) => handleAnswers(event, "ans1")}
            />
            <p className="ms-2 mb-0">Puede ser presidente o vicepresidente</p>
          </div>
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans2.valid}
              type="checkbox"
              value="1"
              checked={answers.ans2.value === "1"}
              onChange={(event) => handleAnswers(event, "ans2")}
            />
            <p className="ms-2 mb-0">Puede ser ministro</p>
          </div>
        </div>
        <div className="col-md-4 col-12 mt-3">
          <img src={Imagen2} alt="amigos" className="img-fluid mb-2" />
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans3.valid}
              type="checkbox"
              value="1"
              checked={answers.ans3.value === "1"}
              onChange={(event) => handleAnswers(event, "ans3")}
            />
            <p className="ms-2 mb-0">Puede ser presidente o vicepresidente</p>
          </div>
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans4.valid}
              type="checkbox"
              value="1"
              checked={answers.ans4.value === "1"}
              onChange={(event) => handleAnswers(event, "ans4")}
            />
            <p className="ms-2 mb-0">Puede ser ministro</p>
          </div>
        </div>
        <div className="col-md-4 col-12 mt-3">
          <img src={Imagen3} alt="amigos" className="img-fluid mb-2" />
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans5.valid}
              type="checkbox"
              value="1"
              checked={answers.ans5.value === "1"}
              onChange={(event) => handleAnswers(event, "ans5")}
            />
            <p className="ms-2 mb-0">Puede ser presidente o vicepresidente</p>
          </div>
          <div className="d-flex align-items-center">
            <input
              className={"form-check-input mb-1 form-md " + answers.ans6.valid}
              type="checkbox"
              value="1"
              checked={answers.ans6.value === "1"}
              onChange={(event) => handleAnswers(event, "ans6")}
            />
            <p className="ms-2 mb-0">Puede ser ministro</p>
          </div>
        </div>
      </div>
      <div className="d-flex w-100 justify-content-end mt-5">
        <button
          className={`btn btn-${modulo9.color}`}
          onClick={validateAnswers}
        >
          Enviar respuestas
        </button>
      </div>

      <ul className="mt-5">
        <li>
          Completa el siguiente texto con una de las palabras del recuadro.
        </li>
      </ul>

      <div className="row">
        <div className="col-md-8 col-12">
          <Card>
            <div className="d-flex justify-content-around">
              <div>nombres</div>
              <div>detalles</div>
              <div>requisitos</div>
              <div>aspectos</div>
            </div>
          </Card>
          <Card>
            <p className="d-inline-block">
              En la actividad anterior hemos hablado de las características que
              se necesitan para ser presidente, vicepresidente o ministro. En
              otras palabras, hemos estado hablando de los{" "}
              <input
                type="text"
                className={
                  "input-text-sm d-inline w-120 form-control me-2 " + ans1.valid
                }
                value={ans1.value}
                onChange={(event) => setAns1({ ...ans1, value: event.value })}
              />
              para esos cargos.
            </p>
          </Card>
        </div>
      </div>
      <div className="row mt-4">
        <div className="col-md-8 col-12">
          <div className="d-flex w-100 justify-content-end mb-4">
            <button
              className={`btn btn-${modulo9.color}`}
              onClick={() =>
                setAns1({
                  ...ans1,
                  valid:
                    ans1.value.toUpperCase() === ans1.correctValue.toUpperCase()
                      ? "is-valid"
                      : "is-invalid",
                })
              }
            >
              Enviar respuestas
            </button>
          </div>
        </div>
      </div>

      <GuiaDocente>
        <p>
          Lea las indicaciones y textos. Dialoguen sobre las respuestas y ayude
          a responder. El sargento solo puede ser ministro (por ser policía),
          Pepe nada (por haber nacido en Japón) y Mónica puede ser las tres
          cosas. Luego, lea la última indicación y el texto. Ayude a responder.
          El concepto tratado en la actividad anterior ha sido el de requisitos.
        </p>
      </GuiaDocente>
    </LayoutActividad>
  );
};

export default Actividad5;
